module.exports = __webpack_public_path__ + "assets/img/excel.5c187dad.png";